// NPM packages
import React from 'react';
import styled from '@emotion/styled';
import { observer } from 'mobx-react-lite';

// All other imports
import Link, { LinkProps } from './Link';
const Root = styled(Link)({
  fontWeight: 'bold',
});

export interface TextLinkProps extends LinkProps {}

function TextLink(props: TextLinkProps): React.ReactElement | null {
  return <Root {...props} />;
}

export default observer(TextLink);
